import config from '../config'
import CoreServices from './coreServices'
import { NOTIFICATION } from '../constants/services'

class NotificationServices extends CoreServices {
  async UPDATE_NOTIFICATION_TOKEN(payload) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}${NOTIFICATION.TOKEN}`, {
        headers: this.headers(this.getToken()),
        body: JSON.stringify(payload),
        method: 'POST'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new NotificationServices(NOTIFICATION.BASE)
